import { BaseService } from '../base/BaseService';
export class AiReportService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiReportService.DEFAULT_SERVICE_PATH,
            basePath: AiReportService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async summarizeRaw(request) {
        return this.http.post(this.buildUrl('summarize'), request);
    }
    async summarize(request) {
        const response = await this.summarizeRaw(request);
        if (!response.data)
            throw new Error('No data returned from report summarization');
        return response.data;
    }
}
AiReportService.DEFAULT_SERVICE_PATH = 'ai-management';
AiReportService.BASE_PATH = 'api/ai/reports';
//# sourceMappingURL=AiReportService.js.map